import {
  useGetFavoriteTemplatesQuery,
  useSetFavoriteTemplateMutation,
  useRemoveFavoriteTemplateMutation,
} from 'store/services/helios/favoriteTemplates';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useSpamGuard } from 'utils/hooks';

import { coreApi } from 'store/services/core';
import { TAG_TYPES } from 'types/services';
type UseSetFavoriteTemplateOptions = {
  templateId?: string;
  skip?: boolean;
};

export const useSetFavoriteTemplate = ({ templateId, skip = false }: UseSetFavoriteTemplateOptions) => {
  const dispatch = useDispatch();

  const { data: favoriteTemplatesData } = useGetFavoriteTemplatesQuery(undefined, { skip });

  const [setFavoriteTemplate, { isLoading: isSettingFavoriteTemplate }] = useSetFavoriteTemplateMutation();
  const [removeFavoriteTemplate, { isLoading: isRemovingFavoriteTemplate }] = useRemoveFavoriteTemplateMutation();

  const { isPending, execute: guardedToggle } = useSpamGuard(isSettingFavoriteTemplate, isRemovingFavoriteTemplate);

  const isPinned = useMemo(
    () => favoriteTemplatesData?.favoriteTemplates?.some((fav) => fav.templateId === templateId) ?? false,
    [favoriteTemplatesData, templateId]
  );

  const favoriteRecordId = useMemo(
    () => favoriteTemplatesData?.favoriteTemplates?.find((fav) => fav.templateId === templateId)?.id,
    [favoriteTemplatesData, templateId]
  );

  const toggleFavoriteTemplate = async () => {
    if (!templateId) return;
    await guardedToggle(async () => {
      if (favoriteRecordId) {
        await removeFavoriteTemplate(favoriteRecordId);
      } else {
        await setFavoriteTemplate(templateId);
      }
      dispatch(coreApi.util.invalidateTags([TAG_TYPES.MODULES]));
    });
  };

  return { toggleFavoriteTemplate, isPinned, isPending };
};
